// src/components/heading/heading.tsx
import { createElement } from "react";
import { tv } from "tailwind-variants";
var heading = tv(
  {
    base: "text-text-neutral-primary",
    variants: {
      weight: {
        light: "font-light",
        normal: "font-normal",
        medium: "font-medium",
        semibold: "font-semibold",
        bold: "font-bold"
      },
      variant: {
        headingMD: "text-3-5xl leading-6 font-display",
        // font size: 32px
        headingSM: "text-2-5xl leading-5 font-display",
        // font size: 28px
        titleLG: "text-2xl leading-8 tracking-tight-2",
        // font size: 24px
        titleMD: "text-xl leading-7 tracking-tight-1",
        // font size: 20px
        titleSM: "text-lg leading-6 tracking-normal",
        // font size: 18px
        titleXS: "text-base leading-6 tracking-normal",
        // font size: 16px
        titleXXS: "text-xs leading-4-5 tracking-normal"
        // font size: 12px
      }
    }
  },
  {
    twMergeConfig: {
      classGroups: {
        "font-size": [
          {
            text: ["3-5xl", "2-5xl", "xxs"]
          }
        ],
        "line-height": [
          {
            leading: ["4-5", "3-5"]
          }
        ],
        tracking: [
          {
            tracking: ["tight-2", "tight-1"]
          }
        ]
      }
    }
  }
);
var Heading = ({
  weight = "normal",
  as,
  className,
  variant,
  children,
  ...rest
}) => {
  const style = heading({ className, weight, variant });
  return createElement(as, { className: style, ...rest }, children);
};
export {
  Heading
};
